<!-- 
Status indicators for a provider contact to indicate whether it is primary, secondary or promoted primary.
-->
<template>
  <span>
    <template v-if="!filtered">
      <v-chip v-if="contact.vslStatus == primary" class="ml-0" disabled>
        <v-avatar class="light-green">VET</v-avatar>
        Primary
      </v-chip>
      <v-chip v-if="contact.helpStatus == primary" class="ml-0" disabled>
        <v-avatar class="light-green">HE</v-avatar>
        Primary      
      </v-chip>
      <v-chip v-if="contact.vslStatus == secondary" class="ml-0" disabled>
        <v-avatar class="lime">VET</v-avatar>
        Secondary
      </v-chip>
      <v-chip v-if="contact.helpStatus == secondary" class="ml-0" disabled>
        <v-avatar class="lime">HE</v-avatar>
        Secondary
      </v-chip>
      <v-chip v-if="contact.vslStatus != primary && contact.promotedVslPrimary == true" class="ml-0" disabled>
        <v-avatar class="orange">VET</v-avatar>
        Promoted Primary
      </v-chip>
      <v-chip v-if="contact.helpStatus != primary && contact.promotedHelpPrimary == true" class="ml-0" disabled>
        <v-avatar class="orange">HE</v-avatar>
        Promoted Primary
      </v-chip>
    </template>
    <template v-else>
      <v-chip v-if="isPrimary(contact)" class="light-green ml-0" disabled>
        <v-avatar><v-icon>account_circle</v-icon></v-avatar>
        Primary contact
      </v-chip>
      <v-chip v-if="isSecondary(contact)" class="lime ml-0" disabled>
        <v-avatar><v-icon>supervisor_account</v-icon></v-avatar>
        Secondary contact
      </v-chip>
      <v-chip v-if="isPromotedPrimary(contact)" class="orange ml-0" disabled>
        <v-avatar><v-icon>accessibility_new</v-icon></v-avatar>
        Promoted Primary
      </v-chip>
    </template>
  </span>
</template>

<script>
export default {
  props: {
    contact: {
      type: Object,
      required: true
    },
    levyCollectionType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      primary: "Primary",
      secondary: "Secondary"
    };
  },
  computed: {
    filtered() {
      return this.levyCollectionType != null;
    },
    vsl() {
      return !this.filtered || this.levyCollectionType == "Vsl";
    },
    help() {
      return !this.filtered || this.levyCollectionType == "Help" || this.levyCollectionType == "Upfront";
    }
  },
  methods: {
    isPrimary(contact) {
      return (contact.vslStatus == this.primary && this.vsl) || (contact.helpStatus == this.primary && this.help);
    },
    isSecondary(contact) {
      return (contact.vslStatus == this.secondary && this.vsl) || (contact.helpStatus == this.secondary && this.help);
    },
    isPromotedPrimary(contact) {
      return (
        (contact.vslStatus != this.primary && contact.promotedVslPrimary == true && this.vsl) ||
        (contact.helpStatus != this.primary && contact.promotedHelpPrimary == true && this.help)
      );
    }
  }
};
</script>

<style lang="scss">
.theme--light.v-chip--disabled {
  color: rgba(0, 0, 0, 0.87) !important;
}
</style>